module.exports = __webpack_public_path__ + "img/bubble_ads.c95c3de9.png";